var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"chartContainer"}),(!_vm.hasData)?_c('div',{staticClass:"no-data-message"},[_vm._v("Biểu đồ chưa có dữ liệu")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }